module.exports = __webpack_public_path__ + "img/facebook.a4b5cf41.svg";